import { Component, computed, inject, input } from '@angular/core';

import { TimeService } from '@core/common-legacy';
import type { AggregatedEvaluationsQuestionResponse } from '@core/evaluations-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { QuestionKind } from '@core/interview-templates-types';
import { EmptyStateComponent, HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-candidate-offer-evaluation-question-responses',
  templateUrl: './candidate-offer-evaluation-question-responses.component.html',
  styleUrl: './candidate-offer-evaluation-question-responses.component.less',
  imports: [EmptyStateComponent, HeadingComponent, TranslatePipe],
})
export class CandidateOfferEvaluationQuestionResponsesComponent {
  private readonly timeService = inject(TimeService);

  public questionTitle = input.required<string | null>();
  public answersCount = input.required<number>();
  public commentsCount = input(0);
  public responses = input.required<AggregatedEvaluationsQuestionResponse[]>();
  public questionKind = input.required<QuestionKind>();

  protected formattedResponses = computed(() =>
    this.responses().map(response => ({
      ...response,
      content: this.formatContent(response.content, response.questionOptions?.currency),
    })),
  );

  private formatContent(content: string, currency?: string): string {
    switch (this.questionKind()) {
      case QuestionKind.Date:
        return content
          ? this.timeService.format({ input: content, pattern: 'DD MMM YYYY' })
          : content;
      case QuestionKind.Salary:
        return this.formatSalary(content, currency);
      default:
        return content;
    }
  }

  private formatSalary(amount: string, currency?: string): string {
    if (!currency) {
      return amount;
    }

    return `${amount} ${currency}`;
  }
}
